module.exports = __webpack_public_path__ + "assets/images/icons/icon_x-orange.svg?v=57a40dcf";